import { createAPIActions } from '../../utils/redux-actions';

export const imagery = createAPIActions('IMAGERY');
export const imageryFiles = createAPIActions('IMAGERY_FILES');
export const imageries = createAPIActions('IMAGERIES');
export const pendingImageries = createAPIActions('PENDING_IMAGERIES');
export const highResolutionImageries = createAPIActions('HIGH_RESOLUTION_IMAGERIES');
export const searchHighResolutionImageries = createAPIActions('SEARCH_HIGH_RESOLUTION_IMAGERIES');
